export default [
  {
    path: '/admin',
    component: () => import('../layouts/admin/AdminLayout.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/DashboardPage.vue'),
      },
      {
        path: 'pin-position',
        name: 'pin-position',
        meta: {
          title: 'Pin Position',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/PinPositionPage.vue'),
      },
      {
        path: 'notifications',
        name: 'notifications',
        meta: {
          title: 'Notifications',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/NotificationsPage.vue'),
      },
      {
        path: 'map',
        name: 'map',
        meta: {
          title: 'Map',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/MapPage.vue'),
      },
      {
        path: 'devices-management',
        name: 'devices-management',
        meta: {
          title: 'Devices Management',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/DevicesManagementPage.vue'),
      },
      {
        path: 'pace-of-play-analytics',
        name: 'pace-of-play-analytics',
        meta: {
          title: 'Pace of Play Analytics',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/PaceOfPlayAnalyticsPage.vue'),
      },
      {
        path: 'profile',
        name: 'profile',
        meta: {
          title: 'Profile',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/ProfilePage.vue'),
      },
      {
        path: 'explore',
        name: 'explore',
        meta: {
          title: 'Explore',
          requiresRole: 'admin',
        },
        component: () => import('../views/admin/ExplorePage.vue'),
      },
      {
        path: 'users',
        name: 'users',
        meta: {
          title: 'Users',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/UsersPage.vue'),
      },
      {
        path: 'admin-users',
        name: 'admin-users',
        meta: {
          title: 'Admin Users',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/AdminUsersPage.vue'),
      },
      {
        path: 'adv',
        name: 'adv',
        meta: {
          title: 'Adv',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/AdvPage.vue'),
      },
      {
        path: 'golfclubs',
        name: 'golfclubs',
        meta: {
          title: 'Golf Clubs',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/GolfclubsPage.vue'),
      },
      {
        path: 'devices',
        name: 'devices',
        meta: {
          title: 'Devices',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/DevicesPage.vue'),
      },
      {
        path: 'partners',
        name: 'partners',
        meta: {
          title: 'Partners',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/PartnersPage.vue'),
      },
      {
        path: 'iotee',
        name: 'iotee',
        meta: {
          title: 'IOTee',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/IoteePage.vue'),
      },
      {
        path: 'leading-courses',
        name: 'leading-courses',
        meta: {
          title: 'Leading Courses',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/LeadingCoursesPage.vue'),
      },
      {
        path: 'courserev',
        name: 'courserev',
        meta: {
          title: 'CourseRev',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/CourseRevPage.vue'),
      },
      {
        path: 'events-by-golfclub',
        name: 'events-by-golfclub',
        meta: {
          title: 'Events by Golfclub',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/EventsByGolfclubPage.vue'),
      },
      {
        path: 'superadmin-notifications',
        name: 'superadmin-notifications',
        meta: {
          title: 'Super Admin Notifications',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/SuperAdminNotificationsPage.vue'),
      },
      {
        path: 'maintenances',
        name: 'maintenances',
        meta: {
          title: 'Maintenances',
          requiresRole: 'superadmin',
        },
        component: () => import('../views/superadmin/MaintenancesPage.vue'),
      },
    ],
  },
  {
    path: '/admin/print-pin-position',
    name: 'print-pin-position',
    meta: {
      title: 'Print Pin Position',
      requiresRole: 'admin',
    },
    component: () => import('../views/admin/PrintPinPositionPage.vue'),
  },
]
